(function () {
    var container = document.querySelector(
        'div.padding-right[itemscope][itemtype="http://schema.org/NewsArticle"]'
    );

    if (!container) return;

    var header = document.querySelector('.page-header');
    var headerTop = header ? (header.offsetHeight - 2 + 'px') : '60px';

    var track = document.createElement('div');
    track.style.cssText = 'position:fixed;left:0;height:5px;width:100%;background:#e0e0e0;z-index:999999;top:' + headerTop;

    var bar = document.createElement('div');
    bar.style.cssText = 'height:100%;width:0%;background:#078ece;transition:width .1s linear';

    track.appendChild(bar);
    document.body.appendChild(track);

    function update() {
        var rect = container.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var progress = rect.bottom <= viewportHeight
            ? 1
            : Math.max(0, 1 - (rect.bottom - viewportHeight) / (container.offsetHeight - viewportHeight));

        bar.style.width = (progress * 100) + '%';
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () {
        track.style.top = header ? (header.offsetHeight - 2 + 'px') : '60px';
    }, { passive: true });
    update();
})();
